import { lazy, Suspense } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import PageLoading from "../components/PageLoading";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const SearchPage = lazy(() => import("../pages/search/page"));
const ServicesPage = lazy(() => import("../pages/services/page"));
const AcousticGlazingPage = lazy(() => import("../pages/services/AcousticGlazingPage"));
const EngineersArchitectsPage = lazy(() => import("../pages/services/EngineersArchitectsPage"));
const ProjectSubmissionPage = lazy(() => import("../pages/services/ProjectSubmissionPage"));
const GlassCalculatorPage = lazy(() => import("../pages/services/GlassCalculatorPage"));
const GlassInstallationPage = lazy(() => import("../pages/services/GlassInstallationPage"));
const MirrorInstallationPage = lazy(() => import("../pages/services/MirrorInstallationPage"));
const ProjectsPage = lazy(() => import("../pages/projects/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const ProductsPage = lazy(() => import("../pages/products/page"));
const ProductDetailPage = lazy(() => import("../pages/products/detail/page"));
const DownloadsPage = lazy(() => import("../pages/downloads/page"));
const Blogs = lazy(() => import("../pages/blogs/page"));
const BlogPost = lazy(() => import("../pages/blog/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: (
      <Suspense fallback={<PageLoading />}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/search",
    element: (
      <Suspense fallback={<PageLoading />}>
        <SearchPage />
      </Suspense>
    ),
  },
  {
    path: "/services",
    element: (
      <Suspense fallback={<PageLoading />}>
        <ServicesPage />
      </Suspense>
    ),
  },
  {
    path: "/services/glass-installation-singapore",
    element: (
      <Suspense fallback={<PageLoading />}>
        <GlassInstallationPage />
      </Suspense>
    ),
  },
  {
    path: "/services/mirror-installation-singapore",
    element: (
      <Suspense fallback={<PageLoading />}>
        <MirrorInstallationPage />
      </Suspense>
    ),
  },
  {
    path: "/services/acoustic-glazing-singapore-noise-reduction",
    element: (
      <Suspense fallback={<PageLoading />}>
        <AcousticGlazingPage />
      </Suspense>
    ),
  },
  {
    path: "/services/acoustic-glazing",
    element: <Navigate to="/services/acoustic-glazing-singapore-noise-reduction" replace />,
  },
  {
    path: "/services/glass-engineering-architectural-resources-singapore",
    element: (
      <Suspense fallback={<PageLoading />}>
        <EngineersArchitectsPage />
      </Suspense>
    ),
  },
  {
    path: "/services/engineers-architects",
    element: <Navigate to="/services/glass-engineering-architectural-resources-singapore" replace />,
  },
  {
    path: "/services/commercial-glass-project-submission-singapore",
    element: (
      <Suspense fallback={<PageLoading />}>
        <ProjectSubmissionPage />
      </Suspense>
    ),
  },
  {
    path: "/services/project-submission",
    element: <Navigate to="/services/commercial-glass-project-submission-singapore" replace />,
  },
  {
    path: "/services/laminated-glass-interlayer-calculator-singapore",
    element: (
      <Suspense fallback={<PageLoading />}>
        <GlassCalculatorPage />
      </Suspense>
    ),
  },
  {
    path: "/services/glass-calculator",
    element: <Navigate to="/services/laminated-glass-interlayer-calculator-singapore" replace />,
  },
  {
    path: "/projects",
    element: (
      <Suspense fallback={<PageLoading />}>
        <ProjectsPage />
      </Suspense>
    ),
  },
  {
    path: "/products",
    element: (
      <Suspense fallback={<PageLoading />}>
        <ProductsPage />
      </Suspense>
    ),
  },
  {
    path: "/products/:id",
    element: (
      <Suspense fallback={<PageLoading />}>
        <ProductDetailPage />
      </Suspense>
    ),
  },
  {
    path: "/downloads",
    element: (
      <Suspense fallback={<PageLoading />}>
        <DownloadsPage />
      </Suspense>
    ),
  },
  {
    path: "/about",
    element: (
      <Suspense fallback={<PageLoading />}>
        <AboutPage />
      </Suspense>
    ),
  },
  {
    path: "/about-us",
    element: (
      <Suspense fallback={<PageLoading />}>
        <AboutPage />
      </Suspense>
    ),
  },
  {
    path: "/contact",
    element: (
      <Suspense fallback={<PageLoading />}>
        <ContactPage />
      </Suspense>
    ),
  },
  {
    path: "/blogs",
    element: (
      <Suspense fallback={<PageLoading />}>
        <Blogs />
      </Suspense>
    ),
  },
  {
    path: "/blog/:slug",
    element: (
      <Suspense fallback={<PageLoading />}>
        <BlogPost />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
